/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_OverlineInputs */

const en_bot_overline = /** @type {(inputs: Bot_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot`)
};

const id_bot_overline = /** @type {(inputs: Bot_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot`)
};

/**
* | output |
* | --- |
* | "BystepBot" |
*
* @param {Bot_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_overline = /** @type {((inputs?: Bot_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_overline(inputs)
	return en_bot_overline(inputs)
});